var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m18.133 13.267-5.333-9.6c-.717-1.292-1.708-2-2.8-2s-2.083.708-2.8 2l-5.333 9.6c-.675 1.225-.75 2.4-.209 3.325.542.925 1.609 1.433 3.009 1.433h10.666c1.4 0 2.467-.508 3.009-1.433s.466-2.108-.209-3.325",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 12.292a.63.63 0 0 1-.625-.625V7.5A.63.63 0 0 1 10 6.875a.63.63 0 0 1 .625.625v4.167a.63.63 0 0 1-.625.625M10 15q-.077-.002-.167-.017a.5.5 0 0 1-.15-.05.6.6 0 0 1-.15-.075l-.125-.1a.88.88 0 0 1-.241-.591c0-.217.091-.434.241-.592l.125-.1q.075-.051.15-.075.075-.038.15-.05a.7.7 0 0 1 .325 0 .5.5 0 0 1 .159.05q.075.024.15.075l.125.1c.15.158.241.375.241.591a.88.88 0 0 1-.241.592l-.125.1a.6.6 0 0 1-.15.075.5.5 0 0 1-.159.05c-.05.008-.108.017-.158.017"
  })));
};
export default SvgError;